import {Header} from '@/components';
import {useAuth} from '@/services/auth/';
import {Button} from '@/ui-kit';
import {OktaOutlined} from '@/ui-kit/icons';
import styles from './login.module.scss';

export const LoginPage = () => {
  const {login} = useAuth();

  const onSubmitForm = (e) => {
    e.preventDefault();
    login();
  };

  return (
    <div className={styles.login}>
      <Header data-testid="header" />
      <div className={styles.content}>
        <div className={styles.form}>
          <h3 className={styles.header}>
            Sign in with your Okta account to continue
          </h3>
          <form onSubmit={onSubmitForm}>
            <Button
              type="secondary"
              className={styles.loginButton}
              leftIcon={<OktaOutlined />}
              htmlType="submit"
            >
              Login with Okta
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};
